var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"SpecialCheck-container",class:{'selected': _vm.selected == true}},[_c('v-checkbox',{staticClass:"mt-0 pt-0",attrs:{"value":_vm.selected,"label":_vm.label,"color":"primary","hide-details":"","readonly":""}}),_c('h3',{staticClass:"align-self-center primary--text"},[_vm._v(_vm._s(_vm._f("$currency")(_vm.price.amount)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }